import styled from 'styled-components';

import media from '../../styles/media.style';
import { BLACK, BG_GRAY } from '../../styles/variables.style';

export const Wrapper = styled.div`
  margin: 0;
  background-color: ${({ gray }) => (gray ? BG_GRAY.COMMON_1 : 'unset')};
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: rows;
  margin: 0 0 20px 20px;

  ${media.tabletP`
    margin: 0 0 20px 40px;
  `};
`;

export const Item = styled.div`
  display: flex;
  flex-direction: rows;
  color: ${BLACK};
  font-size: 14px;

  ${media.tabletP`
    font-size: 16px;
  `};
`;

export const NameWrapper = styled.div`
  // overflow-wrap: break-word は、IE、Firefox、Edge だと使えないので使用しない
  // SP 版の時は、単語が切れないように改行させる
  word-wrap: break-word;

  ${media.tabletP`
    white-space: nowrap;
    word-break: break-all;
  `};

  &.withLink {
    text-decoration: underline;
    text-decoration-color: ${BLACK};

    > a:hover {
      text-decoration: underline;
      text-decoration-color: ${BLACK};
    }
  }
`;

export const Arrow = styled.div`
  margin: 0;
`;

export const Spacer = styled.div`
  width: 8px;
  height: 10px;
`;



// WEBPACK FOOTER //
// ./src/components/BreadCrumbMenus/BreadCrumbMenus.style.js